import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Button } from '@app/components/Button';
import Table from '@app/components/Table';
import TableResponsive from '@app/components/TableResponsive';
import theme from '@app/styles/theme';
import { screenMedium } from '@app/styles/theme/breakpoints';

export const OrderHistoryTable = styled(Table)`
  & td,
  & th {
    width: 23%;

    @media screen and (min-width: ${screenMedium}) {
      &[data-table='order-products'] {
        width: 60%;
      }
    }
  }
`;

export const OrderHistoryTableMobile = styled(TableResponsive)`
  & th {
    white-space: nowrap;
  }
  & td,
  & th {
    width: 20%;

    &[data-table='order-products'] {
      max-width: 65vw;
      text-overflow: ellipsis;
      overflow: hidden;

      span {
        span {
          white-space: nowrap;
        }
      }
    }
  }
`;

export const boxStyles = css`
  &:not(:last-of-type) {
    border-bottom: 1px solid ${theme.colors.lightGray};
  }
`;

export const LoadMoreButton = styled(Button)`
  margin: 20px auto 0 auto;
  display: flex;
`;
